import React, { useState, useEffect } from "react";
import { IModulesPage } from "./types";
import congratsPic from '../../../assets/congrats.png';
import transeferenciaPic from '../../../assets/transferencia.jpeg';

const calculateCurrentWeek = (startDate: string): number => {
  const start = new Date(startDate);
  const today = new Date();
  const diffInMs = today.getTime() - start.getTime();
  const diffInWeeks = Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 7)) + 1;
  return diffInWeeks > 0 ? diffInWeeks : 1;
};

const PaymentsPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [modules, setModules] = useState<IModulesPage[]>([]);
  const [paidWeeks, setPaidWeeks] = useState<number[]>([]);

  const token = localStorage.getItem("token");
  const id = localStorage.getItem("id");

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/record`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && data.length > 0 && data[0].startDate) {
          setStartDate(data[0].startDate);
        }
      })
      .catch((err) => console.error("Error al obtener el record:", err));
  }, []);

  useEffect(() => {
    if (!startDate) return;

    fetch(`https://has-backend-c48d669d897f.herokuapp.com/student/modules/${id}/modules`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setModules(data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error al cargar módulos:", err);
        setIsLoading(false);
      });
  }, [startDate]);

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/payment/${id}/payments`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const paid = data.map((p: any) => Number(p.week));
        setPaidWeeks(paid);
      })
      .catch((err) => {
        console.error("Error al obtener pagos:", err);
      });
  }, []);

  const currentWeek = startDate ? calculateCurrentWeek(startDate) : 0;
  const currentModule = modules.find((mod) => Number(mod.week) === currentWeek);
  const nextModule = modules.find((mod) => Number(mod.week) === currentWeek + 1);

  const unpaidFutureModules = modules
    .filter((mod) => Number(mod.week) >= currentWeek && !paidWeeks.includes(Number(mod.week)))
    .sort((a, b) => Number(a.week) - Number(b.week))
    .slice(0, 4);

  const handlePayment = async (modulesToPay: IModulesPage[]) => {
    try {
      const response = await fetch("https://has-backend-c48d669d897f.herokuapp.com/create-session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          studentId: id,
          modules: modulesToPay.map((m) => ({ id: m._id, name: m.title })), // ✅ ESTRUCTURA CORRECTA
        }),
      });
  
      const data = await response.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        console.error("Error inesperado:", data);
      }
    } catch (error) {
      console.error("Error en el pago:", error);
    }
  };
    

  const renderModuleRow = (mod: IModulesPage) => (
    <div key={mod._id} className="flex flex-row justify-between border-y border-gray-600 py-2 px-4 sm:px-12 text-sm sm:text-base">
      <p className="font-sourceSans">{mod.title}</p>
      <p className="font-sourceSans">Semana {mod.week}</p>
    </div>
  );

  const renderPaymentSection = (title: string, module: IModulesPage | undefined) => {
    const isPaid = module && paidWeeks.includes(Number(module.week));
    return (
      <div className="flex flex-col items-start gap-4 mt-12 w-full">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full gap-2 sm:gap-0">
          <h2 className="font-playfair font-bold text-2xl sm:text-4xl">{title}</h2>
          {!isPaid && module && (
            <button
              className="bg-[#1c1c2e] text-white font-sourceSans rounded-lg shadow-md w-full sm:w-[23%] py-2"
              onClick={() => handlePayment([module])}
            >
              Pagar
            </button>
          )}
        </div>
        {isPaid ? (
          <div className="flex flex-col items-center text-center gap-4 w-full">
            <img src={congratsPic} alt="Pago exitoso" className="w-2/3 sm:w-1/2 h-auto" />
            <p className="font-sourceSans">¡Felicidades! Ya pagaste este módulo</p>
          </div>
        ) : module ? (
          <div className="w-full flex flex-col">
            <div className="flex flex-row justify-between px-4 sm:px-12 pb-4 font-bold text-sm sm:text-base">
              <p>Módulo</p>
              <p>Semana</p>
            </div>
            {renderModuleRow(module)}
          </div>
        ) : (
          <p>No hay módulo disponible.</p>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen w-full px-4 sm:px-8 flex flex-col">
      <div className="flex-1 overflow-y-auto py-8">
        <div className="flex flex-col items-center w-full">
          <img src={transeferenciaPic} alt="Pago transferencia" className="w-full sm:w-1/2 h-auto rounded-md" />
        </div>
        {renderPaymentSection("Pagar módulo actual", currentModule)}
        {renderPaymentSection("Pagar próximo módulo", nextModule)}

        <div className="flex flex-col items-start gap-4 mt-12 mb-12">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full gap-2 sm:gap-0">
            <h2 className="font-playfair font-bold text-2xl sm:text-4xl">Pagar próximos 4 módulos</h2>
            {unpaidFutureModules.length > 0 && (
              <button
                className="bg-[#1c1c2e] text-white font-sourceSans rounded-lg shadow-md w-full sm:w-[23%] py-2"
                onClick={() => handlePayment(unpaidFutureModules)}
              >
                Pagar
              </button>
            )}
          </div>
          {unpaidFutureModules.length === 0 ? (
            <div className="flex flex-col items-center text-center gap-4 w-full">
              <img src={congratsPic} alt="Pago exitoso" className="w-2/3 sm:w-1/2 h-auto" />
              <p className="font-sourceSans">¡Felicidades! Ya pagaste los módulos del mes.</p>
            </div>
          ) : (
            <div className="w-full flex flex-col">
              <div className="flex flex-row justify-between px-4 sm:px-12 pb-4 font-bold text-sm sm:text-base">
                <p>Módulo</p>
                <p>Semana</p>
              </div>
              {unpaidFutureModules.map(renderModuleRow)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentsPage;
